import { SAMPLE_TEMPLATES } from './templates';

// Keep the existing public sample export available for integrations.
export const SAMPLE_HTML = SAMPLE_TEMPLATES[0].html;
